module.exports = __webpack_public_path__ + "files/c9fe9b2463dd65871875abfcd0a3fb39.png";